import React from "react";

function DirectParent(){
    return(
        <div className="form-content" tabindex="1">
        <ul>
            <li>
                <label className="label-full">Direct Parent <span>*</span></label>
                <label className="switch">
                    <i>No</i>
                    <input type="checkbox" />                    
                    <span className="slider round"><i>Yes</i></span>
                </label>
            </li>
            <li>
                <label>Direct Parent (If Reason is No) <span>*</span></label>
                <input type="text"  placeholder="Direct Parent (If Reason is No)" />
            </li>
            {/* <li>
                <label>Direct Parent Parent (If Yes) <span>*</span></label>
                <input type="text" placeholder="Direct Parent Parent (If Yes)" />
            </li> */}
            <li>
                <label>Start Date of Relationship <span>*</span></label>
                <input type="text" placeholder="Start date of relationship" />
            </li>            
        </ul>        
    </div>
    );
}export default DirectParent